import { render, staticRenderFns } from "./EditPhotoProfile.vue?vue&type=template&id=6b173a15"
import script from "./EditPhotoProfile.vue?vue&type=script&lang=js"
export * from "./EditPhotoProfile.vue?vue&type=script&lang=js"
import style0 from "./EditPhotoProfile.vue?vue&type=style&index=0&id=6b173a15&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports